export const mainId = 'main-content';

export const footerId = 'footer';

export const dataInNumbersId = 'section-data-in-numbers';

export const reviewsId = 'section-reviews';

export const howItWorksId = 'section-how-it-works';

export const shopSearchId = 'section-shop-search';

export const servicesId = 'section-services';

export const benefitsId = 'section-benefits';

export const partnersId = 'section-partners';

export const collaborationId = 'section-collaboration';

export const whyWorthId = 'section-why-worth';

export const payWhenYouSellId = 'section-pay-when-you-sell';

export const contactId = 'section-contact';
